<form clrStepper [formGroup]="jobForm">
  <clr-stepper-panel formGroupName="stepI">
    <clr-step-title>Kunde</clr-step-title>
    <clr-step-description>Name, Kurzbeschreibung, Zeitraum</clr-step-description>
    <clr-step-content>

      <clr-input-container>
        <label>Betreff</label>
        <input clrInput name="name_project" formControlName="name_project" />
        <clr-control-error *clrIfError="'required'">Ein Betreff muss angegeben werden</clr-control-error>
        <clr-control-error *clrIfError="'maxLength'; error as err">Betreff zu lang (max. {{ err.name_projectLenght }} Zeichen)</clr-control-error>
      </clr-input-container>

      <clr-input-container>
        <label>Beschreibung</label>
        <input clrInput name="description" formControlName="description" />
      </clr-input-container>
      <clr-input-container>
        <label>Anfragenummer des Kunden</label>
        <input clrInput name="request_id" formControlName="request_id" />
      </clr-input-container>
      <clr-input-container>
        <label>Bestellnummer des Kunden</label>
        <input clrInput name="order_id" formControlName="order_id" />
      </clr-input-container>
      <clr-input-container>
        <label>Firma (Kunde)</label>
        <input clrInput name="company_name" formControlName="company_name" />
      </clr-input-container>
      <clr-input-container>
        <label>Abteilung (Kunde)</label>
        <input clrInput name="department" formControlName="department" />
      </clr-input-container>
      <clr-input-container>
        <label>Straße</label>
        <input clrInput name="street" formControlName="street" />
      </clr-input-container>
      <clr-input-container>
        <label>Stadt</label>
        <input clrInput name="city" formControlName="city" />
      </clr-input-container>
      <clr-input-container>
        <label>PLZ</label>
        <input clrInput name="postcode" formControlName="postcode" />
      </clr-input-container>
      <app-country-select controlName="country" label="Land" />
      <clr-select-container *ngIf="isUpdateMode">
        <label>Status</label>
        <select clrSelect formControlName="status" required>
          <option value="open" selected>Entwurf</option>
          <option value="confirmed">Akzeptiert</option>
          <option value="running">In Arbeit</option>
          <option value="invoiced">Berechnet</option>
          <option value="finished">Erledigt</option>
        </select>
        <clr-control-error>Statusupdate nicht vergessen!</clr-control-error>
      </clr-select-container>
      <clr-date-container>
        <label>Jobdatum</label>
        <input clrDate type="date" placeholder="{{ jobsData?.job_date | date: 'dd.MM.yyyy' }}" formControlName="job_date" />
      </clr-date-container>
      <br />
      <clr-date-container>
        <label>Lieferdatum</label>
        <input clrDate type="date" placeholder="{{ jobsData?.delivery_date | date: 'dd.MM.yyyy' }}" formControlName="delivery_date" />
      </clr-date-container>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next" [disabled]="jobForm.invalid">Weiter</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="!isUpdateMode" [routerLink]="['/project/details', splitProjectNumber(projectId, 0), splitProjectNumber(projectId, 1)]">abbrechen</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="isUpdateMode" [routerLink]="['/job/details', projectId, jobId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepII">
    <clr-step-title>Bearbeiter</clr-step-title>
    <clr-step-description>(seitens PPS - erscheint auf dem Briefbogen)</clr-step-description>
    <clr-step-content>
      <div *ngIf="devMode">Projektleader {{ projectLeader() }} / Bearbeiter geladen: {{ staff.length }}</div>

      <clr-radio-container clrInline>
        <clr-radio-wrapper *ngFor="let employee of staff">
          <input type="radio" clrRadio formControlName="employee_phm" value="{{ employee.staff_id }}" />
          <label [class.leader]="employee.staff_id === projectLeader()">
            <ng-container *ngIf="employee.staff_id === projectLeader(); else defaultName">
              <b>{{ employee.firstname }} {{ employee.lastname }}</b>
            </ng-container>
            <ng-template #defaultName>{{ employee.firstname }} {{ employee.lastname }}</ng-template>
          </label>
        </clr-radio-wrapper>
      </clr-radio-container>
      <div *ngIf="staff.length === 0">Keine Bearbeiter gefunden.</div>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next" [disabled]="jobForm.get('stepII')?.invalid">Weiter</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="!isUpdateMode" [routerLink]="['/project/details', splitProjectNumber(projectId, 0), splitProjectNumber(projectId, 1)]">abbrechen</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="isUpdateMode" [routerLink]="['/job/details', projectId, jobId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepIII">
    <clr-step-title>Ansprechpartner</clr-step-title>
    <clr-step-description>(seitens Kunde - erscheint auf dem Briefbogen)</clr-step-description>
    <clr-step-content>
      <select clrSelect formControlName="employee_leader">
        <option></option>
        <option *ngFor="let person of persons" value="{{ person.pid }}">{{ person.lastname }}, {{ person.firstname }}</option>
      </select>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next" [disabled]="jobForm.invalid">Weiter</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="!isUpdateMode" [routerLink]="['/project/details', splitProjectNumber(projectId, 0), splitProjectNumber(projectId, 1)]">abbrechen</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="isUpdateMode" [routerLink]="['/job/details', projectId, jobId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepIV">
    <clr-step-title>Bedingungen</clr-step-title>
    <clr-step-description>(seitens PPS - erscheint auf dem Briefbogen)</clr-step-description>
    <clr-step-content>
      <label>Angebotsbedingungen: </label>
      <select clrSelect formControlName="cond_offer">
        <option></option>
        <option *ngFor="let condI of offer_conditions" value="{{ condI.cond_id }}">{{ condI.name }}</option>
      </select>
      <br />
      <label>Lieferbedingungen: </label>
      <select clrSelect formControlName="cond_delivery">
        <option></option>
        <option *ngFor="let condII of delivery_conditions" value="{{ condII.cond_id }}">{{ condII.name }} ({{ condII.text }})</option>
      </select>
      <br />
      <label>Zahlungsbedingungen: </label>
      <select clrSelect formControlName="cond_payment">
        <option></option>
        <option *ngFor="let condIII of payment_conditions" value="{{ condIII.cond_id }}">{{ condIII.name }}</option>
      </select>
      <br />
      <clr-input-container>
        <label>Bemerkungen zur Lieferzeit</label>
        <input clrInput formControlName="delivery_remarks" placeholder="... KW nach Auftragserteilung bzw. Materialbereitstellung und technischer Freigabe" />
      </clr-input-container>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next" [disabled]="jobForm.invalid">Weiter</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="!isUpdateMode" [routerLink]="['/project/details', splitProjectNumber(projectId, 0), splitProjectNumber(projectId, 1)]">abbrechen</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="isUpdateMode" [routerLink]="['/job/details', projectId, jobId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepV">
    <clr-step-title>Lieferanschrift</clr-step-title>
    <clr-step-description>(seitens Kunde - erscheint auf Auftragsbestätigung und Lieferschein)</clr-step-description>
    <clr-step-content>

      <app-request-company-search (submitSupplierNumber)="preFillDelivery($event)"></app-request-company-search>

      <clr-input-container>
        <label>Firma (Kunde)</label>
        <input clrInput name="delivery_company" formControlName="delivery_company" />
      </clr-input-container>
      <clr-input-container>
        <label>Abteilung (Kunde)</label>
        <input clrInput name="delivery_department" formControlName="delivery_department" />
      </clr-input-container>
      <clr-input-container>
        <label>Straße</label>
        <input clrInput name="delivery_street" formControlName="delivery_street" />
      </clr-input-container>
      <clr-input-container>
        <label>Stadt</label>
        <input clrInput name="delivery_city" formControlName="delivery_city" />
      </clr-input-container>
      <clr-input-container>
        <label>PLZ</label>
        <input clrInput name="delivery_postcode" formControlName="delivery_postcode" />
      </clr-input-container>
      <app-country-select controlName="delivery_country" label="Land" />
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next" [disabled]="jobForm.invalid">Weiter</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="!isUpdateMode" [routerLink]="['/project/details', splitProjectNumber(projectId, 0), splitProjectNumber(projectId, 1)]">abbrechen</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="isUpdateMode" [routerLink]="['/job/details', projectId, jobId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepVI">
    <clr-step-title>Rechnungsanschrift</clr-step-title>
    <clr-step-description>(seitens Kunde - erscheint auf Rechnung)</clr-step-description>
    <clr-step-content>

      <app-request-company-search (submitSupplierNumber)="preFillInvoice($event)"></app-request-company-search>

      <clr-input-container>
        <label>Firma (Kunde)</label>
        <input clrInput name="invoice_company" formControlName="invoice_company" />
      </clr-input-container>
      <clr-input-container>
        <label>Abteilung (Kunde)</label>
        <input clrInput name="invoice_department" formControlName="invoice_department" />
      </clr-input-container>
      <clr-input-container>
        <label>Straße</label>
        <input clrInput name="invoice_street" formControlName="invoice_street" />
      </clr-input-container>
      <clr-input-container>
        <label>Stadt</label>
        <input clrInput name="invoice_city" formControlName="invoice_city" />
      </clr-input-container>
      <clr-input-container>
        <label>PLZ</label>
        <input clrInput name="invoice_postcode" formControlName="invoice_postcode" />
      </clr-input-container>
      <app-country-select controlName="invoice_country" label="Land" />
      <clr-input-container>
        <label>Umsatzsteuer-ID</label>
        <input clrInput name="invoice_vat_id" formControlName="invoice_vat_id" />
      </clr-input-container>
      <clr-input-container>
        <label>Leitweg-ID (XRechnung)</label>
        <input clrInput name="invoice_leitweg_id" formControlName="invoice_leitweg_id" />
      </clr-input-container>
      <clr-input-container>
        <label>E-Invoice Endpoint</label>
        <input clrInput name="invoice_einvoice_endpoint" formControlName="invoice_einvoice_endpoint" />
      </clr-input-container>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="submit" [disabled]="jobForm.invalid" (click)="updateJob()">Änderungen speichern</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="!isUpdateMode" [routerLink]="['/project/details', splitProjectNumber(projectId, 0), splitProjectNumber(projectId, 1)]">abbrechen</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="isUpdateMode" [routerLink]="['/job/details', projectId, jobId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

</form>


<pre *ngIf="devMode" class="datepicker-output">
    {{ jobForm.value | json }}
</pre>

<pre *ngIf="devMode" class="datepicker-output">
    {{ jobsData | json }}
</pre>
